//@flow
import { init } from '@rematch/core';
import { reducer as toastrReducer } from 'react-redux-toastr';
import 'react-redux-toastr/lib/css/react-redux-toastr.min.css';
import thunk from 'redux-thunk';
import * as models from '../models';
import { alert } from '../reducers/alert.reducer';
import { fieldMessage } from '../reducers/fieldMessage.reducer';

export const store = init({
  models,
  redux: {
    reducers: {
      alert,
      toastr: toastrReducer,
      fieldMessage,
    },
    middlewares: [thunk],
  },
});
